import appSync from '@/_services/appsync.service.js'
import gql from 'graphql-tag'

export const generalServices = {
  getAllExchanges,
  getExchange
}

const GET_EXCHANGE = gql`query exchange($input: ExchangeInput!) {
  exchange(input: $input) {
    exchangedPrice {
      currency
      price
    }
  }
}`
async function getExchange({ price, destinationCurrency }) {
  try {
    const response = await appSync.query({
      query: GET_EXCHANGE,
      variables: {
        input: {
          price,
          destinationCurrency
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response.data.exchange.exchangedPrice
  } catch (error) {
    return Promise.reject(error)
  }
}

function getAllExchanges({ exchangeBase = 'EUR' }) {
  const price =  {
    price: 1,
    currency: exchangeBase
  }
  return new Promise((resolve, reject) => {
    getAvailableCurrencies()
    .then((response) => {
      let mapCurrencies = response.map(({ name }) => (name))
      return Promise.all(mapCurrencies.map(async (name, index) => {
        const response = await getExchange({ price, destinationCurrency: name })
        return response
      }))
    })
    .then((response) => {
      resolve(response)
    })
    .catch((error) => {
      console.log(error)
    })
  })
}

const CURRENCIES_ENUMS = gql`query {
  __type(name: "Currency") {
     name
     enumValues {
       name
     }
   }
 }`
async function getAvailableCurrencies () {
  try {
    const response = await appSync.query({
      query: CURRENCIES_ENUMS,
      fetchPolicy: 'cache'
    })
    return response.data.__type.enumValues
  } catch (error) {
    return Promise.reject(error)
  }
}
